import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { loadFaceFailLog } from '../../../lib/api/runningtrackMonitor';
import { ModalHead, ModalBody, Hint, TableWrap, Tbl, Empty, Who } from './ZetaUi';
import ZetaMemberModal from './ZetaMemberModal';
import { md, clock, fromUnix, toUnix, addDays } from './zetaUtil';

// 로그인 유형 그래프의 막대를 누르면 — 그날 그 유형으로 로그인한 회원.
//   지금 서버에는 로그인 방식별 «횟수»만 있어서(clubloginlog), 회원을 알 수 있는 것은
//   얼굴 실패 뒤 번호로 로그인한 회원(facefaillog 의 번호 로그인 회원)뿐이다.

const TYPE_LABEL = { face: '얼굴', number: '번호', notLogin: '비로그인' };

const ZetaLoginListModal = ({ open, date, type, count, clubID, socketKey, onClose }) => {
  const [rows, setRows] = useState(null);
  const [memberID, setMemberID] = useState(null);

  useEffect(() => {
    if (!open || type !== 'number' || !date) return;
    let alive = true;
    setRows(null);
    loadFaceFailLog(clubID, toUnix(date), toUnix(addDays(date, 1)) - 1, socketKey)
      .then((res) => {
        if (!alive) return;
        const list = res.data && res.data.result === 1 ? res.data.infos || [] : null;
        setRows(list ? list.filter((f) => f.phoneMemberID > 0).sort((a, b) => a.phoneLoginTime - b.phoneLoginTime) : false);
      })
      .catch(() => alive && setRows(false));
    return () => { alive = false; };
  }, [open, type, date, clubID, socketKey]);

  let body;
  if (type === 'number') {
    body = (
      <>
        <Hint>얼굴로그인에 실패한 뒤 번호로 로그인한 회원만 알 수 있습니다.</Hint>
        <TableWrap>
          <Tbl>
            <thead><tr><th>번호 로그인 시각</th><th>기기</th><th>이름</th><th>회원번호</th></tr></thead>
            <tbody>
              {(rows || []).map((f) => (
                <tr key={f.failKey} className="click" onClick={() => setMemberID(f.phoneMemberID)}>
                  <td>{clock(fromUnix(f.phoneLoginTime || f.dateTime))}</td>
                  <td>{f.machineNumber ? `러닝 ${f.machineNumber}번` : '-'}</td>
                  <td><Who name={f.phoneMemberName} main={f.phoneMemberName || '이름 없음'} /></td>
                  <td className="muted">{f.phoneMemberID}</td>
                </tr>
              ))}
            </tbody>
          </Tbl>
          {rows === null ? <Empty>불러오는 중…</Empty> : rows === false ? <Empty>실패 기록을 불러오지 못했습니다 (관리자 로그인·클럽 권한을 확인해 주세요)</Empty> : !rows.length ? <Empty>이날 얼굴 실패 뒤 번호로 로그인한 회원이 없습니다</Empty> : null}
        </TableWrap>
      </>
    );
  } else if (type === 'face') {
    body = <Empty>얼굴 로그인은 횟수({count || 0}번)만 있어 회원 목록을 볼 수 없습니다.</Empty>;
  } else {
    body = <Empty>비로그인 운동은 회원 정보가 없어서 회원 목록을 만들 수 없습니다. 지금은 횟수({count || 0}회)만 있습니다.</Empty>;
  }

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="md" fullWidth>
      <ModalHead>
        <div>
          <h3>{date ? md(date) : ''} {TYPE_LABEL[type] || ''} {type === 'notLogin' ? '운동' : '로그인'}</h3>
          <div className="meta"><span>{count || 0}{type === 'notLogin' ? '회' : '번'}</span></div>
        </div>
        <IconButton onClick={onClose} size="small" aria-label="닫기"><CloseIcon /></IconButton>
      </ModalHead>
      <ModalBody>{body}</ModalBody>
      <ZetaMemberModal open={!!memberID} memberID={memberID} clubID={clubID} socketKey={socketKey} onClose={() => setMemberID(null)} />
    </Dialog>
  );
};

export default ZetaLoginListModal;
